import React, {memo, Suspense} from "react"
import {MANIFEST} from "@manifest/header"
import {useTemplatedComponent} from "@next/templating"
import connect from "./connect"

type RecentSearchesContentProps = {
    templating: {
        mainTemplate: string
        fallbackTemplate: string
    }
    testid: string
    props?: any
    children?: JSX.Element
}

export const RecentSearchesContent = memo(({templating, testid, props, children}: RecentSearchesContentProps) => {
    const ComponentName = useTemplatedComponent(templating, MANIFEST)

    return (
        <Suspense>
            <ComponentName {...props} data-testid={testid}>
                {children}
            </ComponentName>
        </Suspense>
    )
})
RecentSearchesContent.displayName = "RecentSearchesContent"

export default connect(RecentSearchesContent)
